import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Measurement from './pages/Measurement';

// Tanstack Router
// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}

// Tanstack Query
// Create a query client
const queryClient = new QueryClient();

// Check parameter for non routing mode
const search = window.location.search;
const params = new URLSearchParams(search);
const studyinsuid = params.get('studyinsuid');

if ( studyinsuid ) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <Measurement />
      </QueryClientProvider>
    </StrictMode>,
  );  
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );  
}
